import { Box, Divider, Stack, Typography } from "@mui/material";
import React from "react";
import appcolors from "../../constants/Colors";
import { allIcons } from "../../assets";
import { CURRENCY } from "../../constants/Variables";
import moment from "moment";
import { t } from "i18next";
import { useSelector } from "react-redux";

const ServiceCard = ({
  data,
  handleSelectedService,
  showActions,
  canSelectService,
  showDelete,
  handleDelete,
  index,
  showEdit,
}) => {
    const { currentLanguage } = useSelector((state) => state.translationReducer);
  
  return (
    <Stack
      p={1.5}
      my={1}
      position={"relative"}
      borderRadius={"5px 0px 0px 5px"}
      border={"1px solid #8692A6"}
      sx={{
        cursor: "pointer",
        transition: "background-color 0.3s ease-in-out",
        "&:hover": {
          backgroundColor: "primary.light",
        },
        "&:hover .action-icons": {
          opacity: showActions ? 1 : 0,
          visibility: showActions ? "visible" : "hidden",
        },
      }}
      onClick={() => {
        if (canSelectService) {
          handleSelectedService(data);
        }
      }}
    >
      <Divider
        orientation="vertical"
        variant="middle"
        flexItem
        sx={{
          position: "absolute",
          left: 0,
          top: 0,
          bottom: 0,
          my: 0,
          borderWidth: 4,
          borderRadius: "12px",
          borderColor: "primary.light",
        }}
      />
      <Stack
        direction={"row"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Typography
          variant="body1"
          color={appcolors.black}
          fontWeight={500}
          textTransform={"capitalize"}
        >
          {data?.companyServiceDetails?.serviceSubCategoryId?.name[currentLanguage] ||
            t("hairCut")}
        </Typography>
        <Typography
          variant="body1"
          color={appcolors.black}
          fontWeight={500}
          textTransform={"capitalize"}
        >
          {`${CURRENCY} ${data?.companyServiceDetails?.price?.area || "1200"}`}
        </Typography>
      </Stack>
      <Stack
        direction={"row"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Typography variant="body2">
          {`${moment(data?.start).format("h:mm A")} - ${moment(
            data?.end
          ).format("h:mm A")}`}{" "}
          {data?.workerDetails?.name}
        </Typography>
        {showActions && (
          <Stack
            direction={"row"}
            alignItems={"center"}
            spacing={0.5}
            className="action-icons"
            sx={{
              opacity: 0,
              visibility: "hidden",
              transition:
                "opacity 0.3s ease-in-out, visibility 0.3s ease-in-out",
            }}
          >
            {showEdit && <img src={allIcons.editIcon} width={16} />}
            {showDelete && (
              <img
                src={allIcons.deleteIcon}
                width={16}
                onClick={() => handleDelete(data, index)}
              />
            )}
          </Stack>
        )}
      </Stack>
    </Stack>
  );
};

export default ServiceCard;
